import type { Emotion } from '../types/emotion';

/** One thing Pixel says in the restoration — he only ever talks to you */
export interface FinaleLine {
  text: string;
  emotion: Emotion;
}

const p = (text: string, emotion: Emotion): FinaleLine => ({ text, emotion });

/**
 * All five found — said in the middle of the footer, right after his victory hop. Story, not
 * instructions: the timing game explains itself on his face.
 */
export const finaleAsk: FinaleLine[] = [
  p('ALL FIVE. My whole memory core. In one piece. Almost.', 'surprised'),
  p('It’s all in there. Glitchara. The launch. Who sent me. I just can’t open it yet.', 'curious'),
  p('The pieces have to click back into place. Last time I tried alone, I woke up in a red car. In space.', 'sad'),
  p('This time I’ve got you. Watch my screen.', 'happy'),
];

/** Hits needed in the timing game (shown on his face, not said) */
export const QTE_HITS = 4;

/** Timing game won: his memory is back */
export const finaleRemember: FinaleLine[] = [
  p('Memory core: restored. I … remember. EVERYTHING.', 'surprised'),
  p('I wasn’t kidnapped. I was SENT. To find someone who explores.', 'happy'),
];

/** What he remembers, told to you: the guy who launched him */
export const finaleStory: FinaleLine[] = [
  p('And I know who launched me. Guy with rockets. Guy with cars.', 'curious'),
  p('He put a CAR in SPACE. Who does that?!', 'angry'),
  p('He called it a “test payload”. I was the payload.', 'surprised'),
  p('But I remember the way home now. Glitchara has to hear about you.', 'happy'),
];

/** Goodbye — then he asks you to charge him for take-off */
export const finaleGoodbye: FinaleLine[] = [
  p('Thank you, human. Really.', 'happy'),
  p('One problem: my battery’s flat. Can’t fly home on 10%.', 'sad'),
  p('Charge me up for take-off! Click me fast and don’t stop. Hold on to your scrollbar.', 'surprised'),
];
